module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-test-yourself@2x.81e2cd34.png";